module.exports = __webpack_public_path__ + "img/LOGOUT.f89f8d60.svg";